/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RailRightIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rail Right',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M0 5.167v25.666A1.146 1.146 0 0 0 1.125 32h33.75A1.146 1.146 0 0 0 36 30.833V5.167A1.146 1.146 0 0 0 34.875 4H1.125A1.146 1.146 0 0 0 0 5.167ZM33.3 11.5a.5.5 0 0 1-.5.5h-5.6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5.6a.5.5 0 0 1 .5.5Zm0 6a.5.5 0 0 1-.5.5h-5.6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5.6a.5.5 0 0 1 .5.5Zm-6.6 5a.5.5 0 0 1 .5-.5h5.6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5.6a.5.5 0 0 1-.5-.5ZM2 10h22v20H2Z"
    />
  </svg>`;
};
